import { pb } from '@/core/api';

type FileRecord = {
  id: string;
  collectionId: string;
  [key: string]: unknown;
};

/** Build PocketBase file URL for a record's file field */
export function pbFileUrl(record: FileRecord, filename: string): string {
  if (!filename) return '';
  return pb.files.getURL(record, filename);
}
